import type { CheckpointShapeDiagnostics } from '@/lib/checkpoint/checkpoint-to-shapes'

/** Dev-only checkpoint load diagnostics (no console spam): unsupported kinds, skipped elements. */
export function CheckpointDiagnosticsPanel({
  checkpointDiagnostics,
}: {
  checkpointDiagnostics: CheckpointShapeDiagnostics | null
}) {
  const isDevDiagnosticsEnabled = process.env.NODE_ENV !== 'production'

  if (
    !isDevDiagnosticsEnabled ||
    !checkpointDiagnostics ||
    !(
      Object.keys(checkpointDiagnostics.unsupportedKindIds).length > 0 ||
      checkpointDiagnostics.skippedNoGeometry > 0
    )
  ) {
    return null
  }

  return (
    <div className="absolute left-2 bottom-2 z-50 rounded bg-card/90 border border-border px-2 py-1 text-xs text-foreground">
      <div>
        Checkpoint: {checkpointDiagnostics.renderedElements}/{checkpointDiagnostics.totalElements}{' '}
        rendered
      </div>
      {Object.keys(checkpointDiagnostics.unsupportedKindIds).length > 0 && (
        <div>
          Unsupported kindIds:{' '}
          {Object.entries(checkpointDiagnostics.unsupportedKindIds)
            .map(([k, v]) => `${k}(${v})`)
            .join(', ')}
        </div>
      )}
      {checkpointDiagnostics.skippedNoGeometry > 0 && (
        <div>Skipped (missing geometry/decodedData): {checkpointDiagnostics.skippedNoGeometry}</div>
      )}
    </div>
  )
}
